import { sound } from "@pixi/sound";
import { slotLoop } from "./slotLoop.js";
import { makePresentation } from "./makePresentation.js";
import { PaylinesContainer } from "../components/PaylinesContainer.js";
import { ScalableFrame } from "../components/ScalableFrame.js";
import { slotDefinition } from "../configs/slotDefinition.config.js";

export async function slotInit(scope, ctx) {
    const { scenes, gameLogic, audio, data, resources, layers, app } = ctx;

    const hud = await scenes.show("HUDScene");

    ctx.hud = hud;
    ctx.reels = scenes.get("ReelsScene");

    const reelsOptions = ctx.reels.reels.options;
    const lastCol = reelsOptions.columns.at(-1);
    const fieldWidth = lastCol.x + (lastCol.width ?? reelsOptions.symbolWidth);
    const fieldHeight = reelsOptions.rows * reelsOptions.symbolHeight;

    const frameTex = resources?.get("ReelsFrame");
    if (frameTex) {
        const frame = new ScalableFrame(frameTex, { renderer: app?.renderer, anchor: 0.5 });
        await frame.fitInner(1110, 666);
        frame.x = ctx.reels.reels.x + fieldWidth / 2;
        frame.y = ctx.reels.reels.y + fieldHeight / 2;
        ctx.reels.addChildAt(frame, 0);
    }
    ctx.paylinesContainer = new PaylinesContainer({
        paylines: slotDefinition.paylines,
        colors: slotDefinition.paylineColors,
        columns: reelsOptions.columns,
        symbolWidth: reelsOptions.symbolWidth,
        symbolHeight: reelsOptions.symbolHeight,
        fieldWidth,
        clip: { x: 0, y: 0, width: fieldWidth, height: fieldHeight },
    });
    ctx.reels.find("winLinesContainer").addChild(ctx.paylinesContainer);

    audio.setAllVolume(data.volume);
    audio.muteAll(data.isSoundsMuted);
    audio.muteSfx(data.isSfxMuted);

    hud.setSoundState(!data.isSoundsMuted);

    let musicInstance = null;
    const startMusic = () => {
        if (musicInstance) return;
        musicInstance = sound.play("background_music", { loop: true });
        if (musicInstance && data.isMusicMuted) musicInstance.muted = true;
    };
    ctx.setMusicMuted = (muted) => {
        if (musicInstance) musicInstance.muted = muted;
    };

    const audioCtx = sound.context?.audioContext;
    const tryStart = () => {
        if (!audioCtx || audioCtx.state === "running") {
            audioCtx?.removeEventListener("statechange", tryStart);
            document.removeEventListener("pointerdown", tryStart);
            startMusic();
        }
    };

    tryStart();
    if (!musicInstance) {
        audioCtx?.addEventListener("statechange", tryStart);
        document.addEventListener("pointerdown", tryStart);
    }

    ctx.makePresentation = (result, options = {}) => makePresentation(ctx, result, options);

    return slotLoop;
}
